(function () {
    'use strict';
    /*
     * Copyright (c) 2017-18 In Hand Health.
     * All rights reserved.
     */

    /**
     * A service for interacting with alerts.
     * @ngdoc service
     * @name CommonAlertSvc
     * @memberOf ihh-common-web
     */
    angular
        .module('ihh-common-web')
        .service('CommonAlertSvc', CommonAlertSvc);

    CommonAlertSvc.$inject = ['_'];

    function CommonAlertSvc(_) {
        var attrAction = 'data.action';
        var attrTarget = 'data.target';
        var actionScreen = 'screen';
        var actionUrl = 'external';
        var actionResource = 'resource';
        var targetAlert = 'alerts';

        /**
         * Returns the URL string of an alert, if present.
         * @ngdoc method
         * @name getUrl
         * @memberOf ihh-common-web.CommonAlertSvc
         * @param {Object} alert the alert object
         * @returns {String} the alert URL if present, or null
         */
        this.getUrl = function(alert) {
            if (_.get(alert, attrAction) === actionUrl) {
                var url = _.get(alert, attrTarget);

                return url ? url : null;
            }

            return null;
        };

        /**
         * Returns the resourceId of an alert, if present.
         * @ngdoc method
         * @name getResourceId
         * @memberOf ihh-common-web.CommonAlertSvc
         * @param {Object} alert the alert object
         * @returns {String} the alert resource ID if present, or null
         */
        this.getResourceId = function(alert) {
            if (_.get(alert, attrAction) === actionResource) {
                var resourceId = _.get(alert, attrTarget);

                return resourceId ? resourceId : null;
            }

            return null;
        };

        /**
         * Sets the action target of the alert, depending on which argument is set.
         * Only set one of url or resourceId.  If neither is set, then the action is
         * set to the alert itself.
         * @ngdoc method
         * @name setActionTarget
         * @memberOf ihh-common-web.CommonAlertSvc
         * @param {Object} alert the alert object
         * @param {String} url the alert URL; if null clears the URL for the alert
         * @param {String} resourceId the alert resource; if null clears the URL for the alert
         */
        this.setActionTarget = function(alert, url, resourceId) {
            if (url) {
                _.set(alert, attrAction, actionUrl);
                _.set(alert, attrTarget, url);
            }
            else if (resourceId) {
                _.set(alert, attrAction, actionResource);
                _.set(alert, attrTarget, resourceId);
            }
            else {
                _.set(alert, attrAction, actionScreen);
                _.set(alert, attrTarget, targetAlert);
            }
        };

        /**
         * Returns the URL string of an alert, if present, as an href, prepending a protocol if necessary.
         * @ngdoc method
         * @name getHref
         * @memberOf ihh-common-web.CommonAlertSvc
         * @param {Object} alert the alert object
         * @returns {String} the alert href if present, or null
         */
        this.getHref = function(alert) {
            var url = this.getUrl(alert);

            url = this.prependHref(url);

            return url;
        };

        /**
         * prepends a protocol to a URL string if necessary.
         * @ngdoc method
         * @name getHref
         * @memberOf ihh-common-web.CommonAlertSvc
         * @param {String} url
         * @returns {String} the alert href if present, or null
         */
        this.prependHref = function (url) {
            if (url && url.indexOf("://") < 0) {
                url = 'http://' + url;
            }

            return url;
        };
    }
})();